<template>
  <div>
    <div class="" :style="style" :class="{ isLongLanguage }">
      <module is-first />
      <module v-for="i in sortedSettings.length" :id="`bt_tr_oc_${first7Patch}_${i}`" :key="`bt_tr_oc_${first7Patch}_${i}`" :setting="sortedSettings[i - 1]" :is-last="(first7Patch && i === sortedSettings.length) || (!first7Patch)" :not-first7patch="!first7Patch" />
      <!-- <div class="basalsTable_titleRow"> -->
      <!--   <div class="basalsTable_titleRow--first"> -->
      <!--     00:00 00:00 -->
      <!--   </div> -->
      <!--   <div class="basalsTable_titleRow--oneColumn" v-for="i in 7" :key="`bt_tr_oc_${i}`"> -->
      <!--     {{ sortedSettings[i - 1] ? sortedSettings[i - 1]['settingName'] : ''}}<sub v-show="sortedSettings[i - 1] && (sortedSettings[i - 1]['isActive'] + '').trim() === '0'">*</sub> -->
      <!--   </div> -->
      <!-- </div> -->
      <!-- <div class="basalsTable_contentRow" :class="{ 'basalsTable_contentRow--firstRow': j === 1, 'basalsTable_contentRow--lastRow': j === 24 }" v-for="j in 24" :key="`bt_cr_${j}`"> -->
      <!--   <div class="basalsTable_contentRow--first"> -->
      <!--     {{`${j - 1}`.padStart(2, '0')}}:00 -->
      <!--   </div> -->
      <!--   <div class="basalsTable_contentRow--oneColumn" v-for="i in 7" :key="`bt_cr_oc_${j}_${i}`"> -->
      <!--     {{ sortedSettings[i - 1] ? sortedSettings[i - 1]['values'][j - 1] : ''}} -->
      <!--   </div> -->
      <!-- </div> -->
    </div>
    <div class="tip">*: {{ $t('Star indicates that this basal rate module is the one currently being used by the user, as of the time the data was uploaded') }}</div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
import Module from './BasalsTableModule'

const derror = derrorFactory('BolusCalculatorSettingTable.vue', false)
const error = errorFactory('BolusCalculatorSettingTable.vue', true)

let _id = 1
export default {
  name: 'CBolusCalculatorSettingTableV3',
  components: {
    Module
  },
  mixins: [reDrawTrigger],
  props: {
    settings: {
      type: [Array],
      default: () => []
    },
    first7Patch: { // 如果是false，意味着取第8-14个预设值(equils最多有8套预设值)
      type: [Boolean, String, Number],
      default: () => true
    }
  },
  data() {
    _id++
    const id = `basalstablev3_${+new Date()}_${_id}`
    
    return {
      id,
    }
  },
  computed: {
    w() {      
      const { ds } = this
      
      return ds * (1060 / 1740)
      // return ds * (760 / 1740)
      // return ds * (1140 / 1740) // 这个才对得起3列。750是2列。但是3列的话右侧放不下了
      // return ds * (1160 / 1740)
    },
    style() {
      const { first7Patch, showMarginRight, zoomRatio, w } = this
      const rst = { zoom: zoomRatio, width: `${w}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      
      if (!first7Patch) {
        rst.marginTop = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    },
    sortedSettings() {
      const { first7Patch, settings = [] } = this
      
      const tmp = []
      let tmp2
      
      const _mock = false
      
      for (let i = 0; i < 8; i++) {
        let obj = settings[i]
        
        if (!obj) {
          if (_mock) {
            // mock,test,dev;做假的预设值setting
            obj = {
              settingName: 'mock' + (1 + i),
              valueArray: Array.from({ length: 48 }).map(v => '1.111').join(','),
              settingIndex: i
            }
            tmp[i] = obj
            // End mock,test,dev
          } else {
            continue
          }
        }
        
        const arr = obj.valueArray || ''
        const ori48 = arr.split(',')
        
        // 24小时，按一小时一小时合并
        const values = Array.from({ length: 24 }).map(v => '')

        for (let i = 0; i < 24; i++) {
          const s = i * 2
          const e = s + 1
          const notSame = String(ori48[s]) !== String(ori48[e])
          
          if (!notSame) {
            values[i] = ori48[s]
          } else {
            // 这个小时，有两种值
            values[i] = `${ori48[s]} , ${ori48[e]}`
          }
        }
        
        if (_mock) {
          // mock,test,dev;做假的预设值setting
          tmp[i] = ({ ...obj, values })
          // End mock,test,dev
        } else {
          tmp.push({ ...obj, values })
        }
      }

      // console.error(`tmpRst, tmp: `, tmp)
      
      if (first7Patch) {
        const l = Math.min(tmp.length, 7)
        tmp2 = tmp.slice(0, l)
      } else {
        let obj = tmp[7]
        
        if (!obj) {
          if (_mock) {
            obj = {
              settingName: 'mock8',
              values: Array.from({ length: 24 }).map(v => '1.111'),
              valueArray: Array.from({ length: 48 }).map(v => '1.111').join(','),
              settingIndex: 7
            }
          } else {
            obj = {}
          }
        }

        tmp2 = [obj]
      }

      const tmpRst = tmp2.sort((a, b) => a.settingIndex - b.settingIndex)
      // console.error(`tmpRst`, {
      //   tmpRst, first7Patch
      // })
      return tmpRst
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 40px;

.basalsTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;

    .basalsTable_titleRow--first, .basalsTable_contentRow--first {
        width: 60 / 1023 * 100%;
    }
    .basalsTable_titleRow--oneColumn, .basalsTable_contentRow--oneColumn {
        width: 120 / 1023 * 100%;
    }
    .basalsTable_titleRow {
        @include bBox;
        height: $rowH;
        margin-bottom: 10px;
        @include flexRow(space-between, center);
        .basalsTable_titleRow--oneColumn {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            @include heightMiddle($rowH);
            text-align: center;
            border-radius: 4px;
            .ctn-unit {
                margin-left: 0.4em;
            }
        }
        .basalsTable_titleRow--first {
            color: white;
            /* color: rgba(0, 0, 0, 0.5); */
            font-size: 16px;
            text-align: center;
            @include heightMiddle($rowH);
        }
    }
    .basalsTable_contentRow {
        $h: 26px;
        $r: 4px;
        @include bBox;
        @include flexRow(space-between, center);
        font-weight: normal;
        border-bottom: 0.5px solid $colorEchartStripeInnerBorder;
        > * {
            display: inline-block;
            vertical-align: middle;
        }
        .basalsTable_contentRow--first {
            color: rgba(0, 0, 0, 0.5);
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            font-size: calc(16em / 18);            
            font-weight: 600;
            text-align: center;
            @include heightMiddle($h);
        }
        .basalsTable_contentRow--oneColumn {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            @include heightMiddle($h);
            text-align: center;
            .ctn-unit {
                margin-left: 0.4em;
            }
        }

        &.basalsTable_contentRow--firstRow {
            .basalsTable_contentRow--oneColumn {
                border-top-left-radius: $r;
                border-top-right-radius: $r;
            }
        }
        &.basalsTable_contentRow--lastRow {
            border-bottom-right-radius: $r;
            border-bottom: none;
            .basalsTable_contentRow--oneColumn {
                border-bottom-left-radius: $r;
                border-bottom-right-radius: $r;
            }
        }
    }
}
.tip {
    color: rgba(0, 0, 0, 0.76);
    font-size: 0.6em;
    margin-top: 0.6em;
    width: 90%;
}
</style>
